<hr />

<div class="opening-hours-header">
  <!-- Heading and description -->
  <div class="opening-hours-text">
    <div class="opening-hours-heading" [class.closed]="isClosed">
      <span (click)="printDebugInfo()">{{ heading }}</span>
      <i [class.icon-missing]="!isCompleted" [class.icon-completed]="isCompleted"></i>
    </div>
    @if (description) {
      <div class="opening-hours-description">{{ description }}</div>
    }
  </div>

  <!-- Closed checkbox -->
  <div class="opening-hours-closed-checkbox">
    <label [for]="heading" class="checkbox-label">
      <input [id]="heading" [name]="heading" type="checkbox" class="lh-checkbox" [(ngModel)]="isClosed" />
      {{ 'CLOSED' | translate }}
    </label>
  </div>
</div>

<div class="opening-hours-functions-top">
  @if (!isClosed) {
    <!-- Open 24 hours checkbox -->
    <label class="checkbox-label">
      <input type="checkbox" class="lh-checkbox" [(ngModel)]="isOpenAllDay" />
      {{ 'OPEN_24_HOURS' | translate }}
    </label>

    <!-- Inherit normal hours checkbox -->
    <label class="checkbox-label" [hidden]="!allowInherit">
      <input type="checkbox" class="lh-checkbox" [(ngModel)]="inheritNormalHours" />
      {{ 'INHERIT_NORMAL_HOURS' | translate }}
    </label>
  }
</div>

@if (openingHours) {
  <div class="opening-hours-time-interval-list" [hidden]="isClosed || inheritNormalHours">
    <!-- Time interval pickers -->
    <div *ngFor="let timeInterval of openingHours; let i = index" class="opening-hours-time-interval">
      <lh-time-interval-picker
        [(timeInterval)]="openingHours[i]"
        [isOpenAllDay]="isOpenAllDay"
        [inherit]="inheritNormalHours"
        (timeIntervalChange)="onTimeIntervalChange($event)"
      >
      </lh-time-interval-picker>
      <button *ngIf="i > 0" class="btn btn-link btn-remove" (click)="removeTimeInterval(i)">
        <i class="icon-remove"></i>
      </button>
    </div>

    <!-- Add open hours button -->
    <a
      *ngIf="openingHours.length < 3"
      class="href"
      (click)="addTimeInterval()"
      [hidden]="isOpenAllDay || inheritNormalHours"
    >
      {{ 'ADD_OPEN_HOURS' | translate }}
    </a>
  </div>
}

@if (showRemove) {
  <div class="opening-hours-functions-bottom">
    <!-- Remove button -->
    <button class="btn btn-sm btn-default btn-remove" [class.mt-2]="isClosed" (click)="requestRemove()">
      {{ 'REMOVE' | translate }}
    </button>
  </div>
}
